// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HotKey-base__u6Htj{font:var(--font-caption-small-400);font-feature-settings:var(--feature-settings-caption-small-400);letter-spacing:var(--letter-spacing-caption-small-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "HotKey-base__u6Htj"
};
export default ___CSS_LOADER_EXPORT___;
